import type { ButtonProps } from "@mantine/core";
import { Button } from "@mantine/core";
import type { ComponentProps } from "react";
import { useNavigate } from "react-router";

type MissingDataActionButtonProps = ButtonProps &
  ComponentProps<"button"> & {
    route: string;
  };

function MissingDataActionButton({
  children = "Fehlende Daten ergänzen",
  route,
  ...rest
}: MissingDataActionButtonProps) {
  const navigate = useNavigate();

  return (
    <Button
      color="primary"
      variant="default"
      w="100%"
      onClick={() => navigate(route)}
      {...rest}
    >
      {children}
    </Button>
  );
}

export { MissingDataActionButton, type MissingDataActionButtonProps };
